export const NR_COLS = 100;
//# sourceMappingURL=NR_COLS.js.map